import { MessageBar, Tree } from '@looker/components';
import { globalTheme } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const StyledErrorLabel = styled(MessageBar)`
  font-size: ${globalTheme.fonts.plainText.fontSize};
  margin-top: 12px;
`;

export const StyledTree = styled(Tree)`
  & [role='treeitem'] {
    background-color: rgba(0, 0, 0, 0) !important;
  }

  & [role='treeitem']:hover {
    background-color: rgba(0, 0, 0, 0) !important;
  }
`;
